import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Cardproduto from '../cardProduto/CardProduto';

function Slider() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  return (
    <Carousel
      swipeable
      draggable
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
      autoplay={true}
      autoPlaySpeed={1000}
      keyBoardControl={true}
      customTransition="all .5"
      transitionDuration={500}
      containerClass="carousel-wrapper"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-40-px"
      centerMode
    >
      <div className="slide"><Cardproduto link={"/fofinhoAbsolut"} logo={"../../../../assets/fofinhoAbs-logo.png"} cor={"#9B9B9D"} /></div>
      <div className="slide"><Cardproduto link={"/fofinhoAbsolutPremium"} logo={"../../../../assets/logoAbsPremium.png"} cor={"#5D699A"} /></div>
      <div className="slide"><Cardproduto link={"/fofinho"} logo={"../../../../assets/fofinhoLogoAzul.png"} cor={"#BAEBFF"} /></div>
      <div className="slide"><Cardproduto link={"/sorella"} logo={"../../../../assets/sorellaLogo.png"} cor={"#C26666"} /></div>
      <div className="slide"><Cardproduto link={"/best"} logo={"../../../../assets/bestLogo.png"} cor={"#DFCF89"} /></div>
      <div className="slide"><Cardproduto link={"/bambino"} logo={"../../../../assets/BambinoLogo.png"} cor={"#BAEBFF"} /></div>

    </Carousel>
  )
}

export default Slider;